import "../../config/editor/quill-font.config";
import "katex/dist/katex.min.js";
import {
    Component,
    EventEmitter,
    Input,
    Output,
} from "@angular/core";
import Quill from "quill";
import QuillTableBetter from "quill-table-better";
import { QUILL_FONT_WHITELIST } from "src/app/config/constants";
import { ContentChange } from "ngx-quill";

Quill.register(
    {
        "modules/table-better": QuillTableBetter,
    },
    true
);

@Component({
    selector: "cc-text-editor",
    standalone: false,
    templateUrl: "./text-editor.component.html",
    styleUrls: ["./text-editor.component.scss"],
})
export class TextEditorComponent {
    @Input() htmlStr = '';
    @Output() htmlStrChange = new EventEmitter<string | null>();
    modules = {
        toolbar: {
            container: [
                ["bold", "italic", "underline", "strike"],
                ["blockquote", "code-block"],
                [{ header: 1 }, { header: 2 }],
                [{ list: "ordered" }, { list: "bullet" }],
                [{ script: "sub" }, { script: "super" }],
                [{ indent: "-1" }, { indent: "+1" }],
                [{ direction: "rtl" }],
                [{ size: ["small", false, "large", "huge"] }],
                [{ header: [1, 2, 3, 4, 5, 6, false] }],
                [{ color: [] }, { background: [] }],
                [{ font: QUILL_FONT_WHITELIST }],
                [{ align: [] }],
                ["clean"],
                ["formula"],
                ["table-better"],
            ],
        },
        table: false,
        "table-better": {
            language: "en_US",
            menus: [
                "column",
                "row",
                "merge",
                "table",
                "cell",
                "wrap",
                "copy",
                "delete",
            ],
            toolbarTable: true,
        },
        keyboard: {
            bindings: (QuillTableBetter as any).keyboardBindings,
        },
    };

    handleContentChange(event: ContentChange) {
        this.htmlStrChange.emit(event.html);
    }

    EditorCreated = (quill: Quill) => {
        let html = this.htmlStr;
        const delta = quill.clipboard.convert({ html });
        const range = quill.getSelection();

        quill.updateContents(delta, "user");
        quill.scrollSelectionIntoView();
    };
}
